{
  "iframeWaitingMessage": "お待たせしました。あと少し…",
  "otherOrganizations": "その他の組織",
  "solutionIframe": "メインコンテンツ",
  "unloadPromptMessage": "よろしいですか？"
}
